import { getItem } from '@/common/localStorage';
import * as Sentry from "@sentry/vue";
import { API } from "@/new_api";
import router from "@/router";

const defaultState = {
    emailUser: '',
    clickId: null,
    loading: false,
    analyticsParams: {},
    clickTime: null,
    fbclid: ''
}

const state = () => ({
    emailUser: defaultState.emailUser,
    clickId: defaultState.clickId,
    loading: defaultState.loading,
    analyticsParams: defaultState.analyticsParams,
    clickTime: defaultState.clickTime,
    fbclid: defaultState.fbclid
})

const getters = {
    getUsersEmail: state => state.emailUser,
    clickId: state => state.clickId,
    getGeneralLoading: state => state.loading
}

const mutations = {
    SET_CLICK_ID(state, payload) {
        state.clickId = payload
    },
    SET_EMAILUSER(state, payload) {
        state.emailUser = payload;
    },
    SET_LOADING(state, payload) {
        state.loading = payload
    },
    SET_ANALYTICS_PARAMS(state, payload) {
        state.analyticsParams = payload;
    },
    SET_CLICK_TIME(state, payload) {
        state.clickTime = payload;
    },
    SET_FBCLID(state, payload) {
        state.fbclid = payload;
    }
}

const actions = {
    async updateUserEmail({ state, commit, dispatch, getters }, { newEmail, prevEmail }) {
        commit('SET_LOADING', true);

        const params = {
            previous_email: prevEmail,
            new_email: newEmail,
            web_user_uuid: getters.userUuid
        }

        return await API.PAYMENTS.update_user_email(params)
          .then(() => {
              localStorage.setItem('email', newEmail);
              commit('SET_EMAILUSER', newEmail);
          })
          .finally(() => {
            commit('SET_LOADING', false);
        })
    },
    async sendEMAILUUID ({ state, commit, dispatch, getters }, nextPage) {
        commit('SET_LOADING', true);
        localStorage.setItem('email', state.emailUser);

        function getCookie(name) {
            const value = "; " + document.cookie;
            const parts = value.split("; " + name + "=");
            if (parts.length == 2) return parts.pop().split(";").shift();
        }

        const params = {
            email: state.emailUser,
            platform: window.navigator.platform == "iPhone" ? "ios" : "android",
            ga_gclid: Array.isArray(getItem('ga_gclid')) ? "" : getItem('ga_gclid'),
            ga_gbraid: Array.isArray(getItem('ga_gbraid')) ? "" : getItem('ga_gbraid'),
            ga_wbraid: Array.isArray(getItem('ga_wbraid')) ? "" : getItem('ga_wbraid'),
            ga_user_id: Array.isArray(getItem('ga_user_id')) ? "" : getItem('ga_user_id'),
            fbp: localStorage.getItem('fbp') ? localStorage.getItem('fbp') : getCookie("_fbp"),
            fbc: localStorage.getItem('fbc') || getCookie("_fbc") || state.fbclid,
            ad_id: state.analyticsParams.sub1 || localStorage.getItem('sub1'),
            ad_placement: state.analyticsParams.sub7 || localStorage.getItem('sub7'),
            ad_source: state.analyticsParams.utm_source || localStorage.getItem('utm_source'),
            click_id: state.clickId,
            click_time: state.clickTime || localStorage.getItem('b_click_time'),
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            pixel: sessionStorage.getItem('pixelId') || '2763129137174448',
            web_user_uuid: getters.userUuid,
            tiktok_click_id: localStorage.getItem('ttclid') || localStorage.getItem('tiktok_click_id') 
        }

        if (!params.click_id) {
            Sentry.captureMessage(`Lead - click_id: ${params.click_id}, uuid: ${params.web_user_uuid}, email: ${params.email}, platform: ${params.platform}`)
        }

        try {
            const { status } = await API.PAYMENTS.init_user(params);

            if (status === 200 || status === 204) {
                if (ttq) ttq.track('Complete Registration')
                router.push({name: nextPage, params: {uuid: getters.userUuid, email: state.emailUser}});
            }

        } catch(error) {
            console.error(error)
        } finally {
            commit('SET_LOADING', false)
        }
    },

    storeClickId({ commit, state }, payload) {
        const savedClickID = localStorage.getItem('b_click_id');

        if (!savedClickID && state.clickId) {
            localStorage.setItem('b_click_id', state.clickId);
        }

        if (state.clickId) return
        localStorage.setItem('b_click_id', payload);
        commit('SET_CLICK_ID', payload);
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
